// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__dy6L-","header":"MergedInvoice_header__TKxTl"};